import { Button, Icon, Modal, Typography } from '@globalmed/atlas-ui';
import { useTranslation } from 'react-i18next';
import styles from './KioskAttachmentRestrictionModal.module.css';

type TProps = {
  open: boolean;
  onClose: () => void;
};

/**
 * Renders a modal informing users that attachments cannot be opened on a kiosk.
 * @param props - Component props.
 * @param props.open - Controls whether the modal is open.
 * @param props.onClose - Callback triggered when the user closes the modal.
 * @returns KioskAttachmentRestrictionModal component.
 */
export const KioskAttachmentRestrictionModal = ({ open, onClose }: TProps) => {
  const { t } = useTranslation();
  return (
    <Modal
      open={open}
      title={
        <div className={styles.container}>
          <Icon
            name="XCircle"
            color="var(--colors-error700)"
            size="48"
            decorative
          />
          <Typography
            fontWeight={600}
            fontSize="20px"
            sx={{ lineHeight: '30px' }}
          >
            {t('kiosk.attachments-cannot-be-opened-on-kiosk')}
          </Typography>
          <Typography
            color="var(--colors-secondary)"
            sx={{ lineHeight: '20px', textAlign: 'center' }}
          >
            {t('kiosk.please-use-your-own-device')}
          </Typography>
        </div>
      }
      body={<Button text={t('got-it')} onClick={onClose} wide />}
    />
  );
};
